// /src/components/layout/Layout.tsx
import React from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <Box h="100vh" overflow="hidden">
      <Header />
      <Flex h="calc(100vh - 60px)">
        <Sidebar />
        <Box flex="1" overflowY="auto" bg="gray.100" p={6}>
          {children}
        </Box>
      </Flex>
    </Box>
  );
};
